<template>
  <Dialog header="Deleted" v-model:visible="visible" :closable="false"
    :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }" :style="{ width: '30vw' }" :modal="true">
    <img class="success" src="../../assets/Gif/delete.gif" />
    <p class="msg mt-3">{{ $t("confirmation.declinedsuccess") }}</p>
    <template #header>
      <Button icon="pi pi-times d-flex d-flex-reverse" @click="$emit('Ok')" />
    </template>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
export default defineComponent({
  props: {
    visible: {
      readonly: false,
      type: Boolean,
      default: ref(false),
      life: 1000,
    },
  },
  setup() {
    return {};
  },
});
</script>
<style lang="scss" scoped>
.success {
  width: 100px;
}
</style>
